import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { TurnoverScreen } from '@/features/hr-reports/turnover-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/turnover')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: TurnoverScreenRoute,
})

function TurnoverScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <TurnoverScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/turnover', search: next })}
    />
  )
}
